const VITE_FLAG_USE_INTEGRATIONS_V2 = import.meta.env
  .VITE_FLAG_USE_INTEGRATIONS_V2

const useNewIntegrations = VITE_FLAG_USE_INTEGRATIONS_V2 === 'true'

const VITE_USE_FORM_BUILDER = import.meta.env.VITE_USE_FORM_BUILDER

const useFormBuilder = VITE_USE_FORM_BUILDER === 'true'

export default { useFormBuilder, useNewIntegrations }

export { useFormBuilder, useNewIntegrations }
